module.exports = __webpack_public_path__ + "assets/img/111.bed12d50.jpg";